import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';

@Component({
  selector: 'app-changeplan-terms-fixed',
  templateUrl: './changeplan-terms-fixed.component.html',
  styleUrls: ['./changeplan-terms-fixed.component.sass']
})
export class ChangeplanTermsFixedComponent implements OnInit {

  constructor(private loadingScreenService :LoadingScreenService,public matDialogRef:MatDialogRef<ChangeplanTermsFixedComponent>,private services: Service,private global:GlobalService,@Inject(MAT_DIALOG_DATA) public data: any, private router:Router) { }

  ngOnInit() {
  }
  public close(){
    if(this.global.validateSession()===true){
      this.matDialogRef.close('cancel');
    }
  }
}
